@if (pendingIssues().result.length === 0 && isEveryBookSent()) {
  <div class="flex h-[85svh] flex-col items-center justify-center">
    <img class="mb-6 size-32" src="assets/images/empty-pending-issues.webp" />
    <h2 class="font-roboto text-base font-semibold text-neutral-low-pure">
      Tudo certo por aqui
    </h2>
    <p
      class="text-center font-roboto text-sm font-normal text-neutral-low-pure"
    >
      Nenhuma pendência foi encontrada. Os livros da sua turma já estão em
      produção!
    </p>
    <p
      class="text-center font-roboto text-sm font-normal text-neutral-low-pure"
    >
      Agora é só aguardar o evento de culminância e se encantar com o resultado
      final.
    </p>
  </div>
} @else {
  <div class="flex flex-col gap-3">
    @for (
      pendingIssue of organizedPendingIssues();
      track pendingIssue.classId
    ) {
      <mw-pending-issue-item
        [title]="pendingIssue.className"
        [deadline]="pendingIssue.deadline"
        [issues]="pendingIssue.issues"
        [hasBeenSentToPrinting]="pendingIssue.isFinished || false"
      />
    }
  </div>
}
